import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Create a new password", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    (_ctx.showForm)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          fields: _ctx.fields,
          buttons: _ctx.buttons,
          onFormHasPassedValidation: _ctx.saveFormData
        }, null, 8, ["fields", "buttons", "onFormHasPassedValidation"]))
      : _createCommentVNode("", true)
  ], 64))
}